import { __ } from '@wordpress/i18n'

export default {
  link: __('zur Eventseite', 'dhsv_theme'),
}
